export enum REVENUE_GRADE_SENTENCE {
  LOW_REVENUE = '저조합니다',
  LITTLE_LOW_REVENUE = '다소 저조합니다',
  AVERAGE_REVENUE = '비슷합니다',
  ACCEPTABLE = '양호합니다',
  EXCELLENT = '우수합니다',
}
